import { createStore } from 'vuex'

export default createStore({
  state: {
    showTab:'/management/managementIndex',
    loginStatus:false,
    openTabs:[
      {
        title:'后台首页',
        name:'/management/managementIndex',
      }
    ],
    stuLoginStatus:false,
  },

  getters: {},

  mutations: {
    ADD_TABS: (state,menuItem)=>{
      let menu=menuItem.menu
      let tab=menuItem.item
      if(state.openTabs.findIndex(e=>e.name===("/management"+menu.path+tab.path))===-1){
        state.openTabs.push({
          title:tab.name,
          name:"/management"+menu.path+tab.path
        })
      }
      state.showTab="/management"+menu.path+tab.path
    },
    REST_TAB:(state)=>{
      state.showTab='/management/managementIndex'
      state.openTabs=[
        {
          title:'后台首页',
          name:'/management/managementIndex',
        }
      ]
    },
    LOGIN:(state)=>{
      state.loginStatus=true
    },
    LOGOUT:(state)=>{
      state.loginStatus=false
    },
    STU_LOGIN:(state)=>{
      state.stuLoginStatus=true
    },
    STU_LOGOUT:(state)=>{
      state.stuLoginStatus=false
    },
    SHOW_USER_CENTER:(state)=>{
      state.showTab='/management/sys/userCenterCtrl'
      if(state.openTabs.findIndex(e=>e.name===("/management/sys/userCenterCtrl"))===-1){
        state.openTabs.push({
          title:'个人中心',
          name:'/management/sys/userCenterCtrl',
        })
      }
    }
  },


  actions: {},

  modules: {}
})
